import create from 'zustand'
import { persist } from 'zustand/middleware'

const uuid = () => ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
  // eslint-disable-next-line
  (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
)

const useTimerStore = create(persist(
  (set, get) => ({
    timers: [],
    dateUpdated: 0,
    id: uuid(),

    addTimer: timer => {
      const id = get().timers.reduce((total, t) => Math.max(total, t.id), 0) + 1
      set(state => ({
        timers: [...state.timers, {
          id,
          ...timer,
        }],
        dateUpdated: Date.now(),
      }))
      return id
    },
    editTimer: (id, timer) => set(state => ({
      timers: state.timers.map(t => t.id === id ? {
        ...t,
        ...timer,
      } : t),
      dateUpdated: Date.now(),
    })),
    removeTimer: id => set(state => ({
      timers: state.timers.filter(t => t.id !== id),
      dateUpdated: Date.now(),
    })),
    setId: id => set({ id }),

    setTimers: timers => set({ timers, dateUpdated: Date.now() }),
  }),
  {
    name: 'era-timers',
    version: 0,
  }
))

export default useTimerStore